import _ from 'lodash';
import {Maybe} from './logging';
import {getDOMElementsAttr} from './helpers';

/**
 * initial clean of data prepared for sending to BE
 */
export const initialClean = (data, cleanIndicators) => {
    for(const prop in data) {
        if (cleanIndicators.some((indicator) => {
            return indicator ===  data[prop];
        }) ||  _.isEmpty(data[prop])) {
            delete data[prop];
        }
    }
    return data;
}

/**
 * set data in format required by API
 */
export const setRequiredDataFormat = (normalizedData) => {
    return _.transform(normalizedData, (result, value) => {
        // Maybe.of(value).map((value.Code) => {
        //     result[val.Code] = value.CurrentValue;
        // })

        if (value && value.Code) {
            result[value.Code] = value.CurrentValue;
        }
        return result;
    }, {});
}

/**
* delete fields which are helper fields on FE forms
 */
export const deleteUnnecessaryFields = (normalizedData, fieldsToDelete) => {
    fieldsToDelete.forEach((field) => {
        delete normalizedData[field];
    });
    return normalizedData;
}


export const setSwitchValue = (state, switchers) => {
    var newState = {...state};
    // TODO - set this better - maybe seperate function
    const disabledFields = Array.from(new Set(getDOMElementsAttr(document.querySelectorAll('input:disabled'), 'name')));
    disabledFields
        .filter((field) => {
            return (typeof field !== undefined) && (field !== null)
        })
        .map((field) => {
            return field.split(".")[1];
        })
        .filter((field) => {
            return !(field === 'ZT' || field === 'SZ' || field === 'SIK');
        })
        .forEach((field) => {
            delete newState[field];
        });
    // TODO - fix it
    switchers.forEach((switcher) => {
        if (newState[`${switcher}_switch`].CurrentValue === 1 && !newState[`${switcher}`] ) {
            newState[`${switcher}`] = {
                Code:         switcher,
                CurrentValue: '1',
            };
        } else if (!newState[`${switcher}`]) {
            newState[`${switcher}`] = {
                Code:         switcher,
                CurrentValue: '0',
            };
        }
    });
    return newState;
}

export const setInverterValue = (state, inverters) => {
    var newState = {...state};
    // TODO - fix it
    inverters.forEach((inverter) => {
        if (newState[`${inverter}_inverter`].CurrentValue === '1') {
            newState[`${inverter}`] = {
                Code:         inverter,
                CurrentValue: '0',
            };
        } else {
            newState[`${inverter}`] = {
                Code:         inverter,
                CurrentValue: '1',
            };
        }
    });
    return newState;
}
/**
 * metric unit conversion
 */
export const metricConversion = (val, from = 'mm', to = 'cm') => {
    const basicMetricUnit = 'mm';
    const metrics = [
        {
            name:  'mm',
            value: 1,
        },
        {
            name:  'cm',
            value: 10,
        },
        {
            name:  'dm',
            value: 100,
        },
        {
            name:  'm',
            value: 1000,
        },
    ];
    const fromMetric = metrics.find((metric) => {
        return from === metric;
    }).value;
    const toMetric = metrics.find((metric) => {
        return to === metric;
    }).value;
    return fromMetric > toMetric ? val * toMetric / fromMetric : val * fromMetric / toMetric;
}

/**
 * convert string type number to number type
 */
export const convertStringToNumber = (str) => {
    return parseInt(str.replace(/[']/g, ''));
}

/**
 *  Cleanup orphaned Teilzargen/Schürzenfield and reset original field
 */
export const secureZargenFields = (normalizedData) => {
    const inputFields = ['ZM23', 'ZM45', 'ZM67', 'ZM81', 'SM23', 'SM45', 'SM67', 'SM81'];

    inputFields.forEach((field) => {
        let parentField = field.replace('M','');

        if(normalizedData.hasOwnProperty(parentField)
                && !_.isEmpty(normalizedData[parentField])
                && normalizedData[parentField].length !== 1
                && !normalizedData.hasOwnProperty(field)) {
                normalizedData[parentField] = "1";
        }
    });
    return normalizedData;
}



// WEBPACK FOOTER //
// ./src/utils/prepareData.js